var _path, _path2, _path3, _path4;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgWaitOnPremise = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8375 5.97582C13.8375 8.11025 12.1194 9.84055 10 9.84055C7.88063 9.84055 6.16253 8.11025 6.16253 5.97582C6.16253 3.84138 7.88063 2.11108 10 2.11108C12.1194 2.11108 13.8375 3.84138 13.8375 5.97582Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9542 12.6867C12.1013 12.3561 11.1222 12.1594 10 12.1594C5.14904 12.1594 2.97392 15.8342 2.09086 18.1161C1.74277 19.0157 2.44096 19.8889 3.39956 19.8889H11.865C11.3933 19.0319 11.125 18.0473 11.125 17C11.125 15.3069 11.8263 13.7776 12.9542 12.6867Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 16.4965C19.164 16.4965 19.5 16.8325 19.5 17.2465C19.5 17.6605 19.164 17.9965 18.75 17.9965H17.25C16.836 17.9965 16.5 17.6605 16.5 17.2465V15.2426C16.5 14.8286 16.836 14.5 17.25 14.5C17.664 14.5 18 14.8286 18 15.2426V16.309C18 16.4125 18.084 16.4965 18.1875 16.4965H18.75Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 12C14.4885 12 12.25 14.2385 12.25 17C12.25 19.7615 14.4885 22 17.25 22C20.0115 22 22.25 19.7615 22.25 17C22.2469 14.24 20.01 12.0031 17.25 12ZM17.2492 13.5C15.3164 13.5004 13.75 15.0672 13.75 17C13.75 18.9331 15.3169 20.5 17.25 20.5C19.1828 20.5 20.7496 18.9336 20.75 17.0008C20.7474 15.0686 19.1814 13.5026 17.2492 13.5Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWaitOnPremise, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/waitOnPremise.72aa8aa8.svg";
export { ForwardRef as ReactComponent };